import React from 'react';

const interestComponent = props => {
  return null;
  return (
      <div className="section-wrapper z-depth-1">
        <div className="section-icon col s12 m12 l2">
          <i className="fa fa-plane"/>
        </div>
        <div className="interests col s12 m12 l10 wow fadeIn" data-wow-delay="0.1s">
          <h2>Interestes </h2>
          <ul>
            <li><i className="fa fa-camera-retro tooltipped" data-position="top" data-delay="50"
                   data-tooltip="Photography"/></li>
            <li><i className="fa fa-glass tooltipped" data-position="top" data-delay="50"
                   data-tooltip="Drinking"/></li>
            <li><i className="fa fa-headphones tooltipped" data-position="top" data-delay="50"
                   data-tooltip="Music"/></li>
            <li><i className="fa fa-comments tooltipped" data-position="top" data-delay="50"
                   data-tooltip="Chatting"/></li>
            <li><i className="fa fa-coffee tooltipped" data-position="top" data-delay="50"
                   data-tooltip="Coffee"/></li>
          </ul>
        </div>
      </div>
  )
};

export default interestComponent;
